import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import classNames from 'classnames';

import s from '../../styles/reactTableCustomization.module.scss';
import Spinner from '../spinner/Spinner.jsx';

const PAGE_SIZE = 100;

const VENUE_COLUMNS = [
    {
        Header: 'NAME',
        accessor: 'name',
        width: 400,
    },
    {
        Header: 'VENUE ID',
        accessor: 'id',
        width: 150,
    },
];

export default class VenueList extends PureComponent {
    static propTypes = {
        venuesToRender: PropTypes.arrayOf(PropTypes.object),
        onVenueSelect: PropTypes.func,
        loading: PropTypes.bool,
        className: PropTypes.string,
        hasLoaded: PropTypes.bool,
    };

    static defaultProps = {
        venuesToRender: [],
        onVenueSelect: () => {},
        hasLoaded: false,
    };

    renderErrorMessage = (displayMessage, hasLoaded) => {
        if (displayMessage && hasLoaded) {
            return <div className={s.errorMessage}>No venues found</div>;
        }
    };

    render() {
        const classes = ['-striped', '-highlight'];
        const { venuesToRender, onVenueSelect, loading, className, hasLoaded } = this.props;
        const needsPagination = venuesToRender.length > PAGE_SIZE;
        const noData = !loading && venuesToRender.length === 0;

        return (
            <div className={classNames(s.venueList, className)}>
                <Spinner loading={loading} />
                <ReactTable
                    data={venuesToRender}
                    className={classNames(classes)}
                    columns={VENUE_COLUMNS}
                    loading={loading}
                    loadingText="Loading Venues"
                    getTdProps={(state, rowInfo) => ({ onClick: () => onVenueSelect(rowInfo.original.id) })}
                    defaultPageSize={PAGE_SIZE}
                    showPageSizeOptions={false}
                    showPagination={needsPagination}
                    previousText="<"
                    nextText=">"
                    minRows={0}
                />
                {this.renderErrorMessage(noData, hasLoaded)}
            </div>
        );
    }
}
